<template>
  <div class="container page">
    <van-nav-bar :title="$t('交易密码')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()"/>
      </template>
    </van-nav-bar>
    <div class="loginForm">

      <div class="label" style="margin-top: 30px">{{ $t("旧密码") }}</div>
      <van-field v-model="old_password"  :placeholder="$t('请输入旧密码')" />

      <div class="label" style="margin-top: 30px">{{ $t("新密码") }}</div>
      <van-field
          v-model="o_new_password"
          :type="passwordType"
          class="input"
          :placeholder="$t('请输入新密码')">
        <template slot="right-icon">
          <van-icon :name=" passwordType === 'password' ? 'closed-eye':'eye-o'" @click="passwordType = passwordType == 'password'?'text':'password'"/>
        </template>
      </van-field>

      <div class="label" style="margin-top: 30px">{{ $t("新密码") }}</div>
      <van-field
          v-model="t_new_password"
          :type="passwordType1"
          class="input"
          :placeholder="$t('请输入新密码')">
        <template slot="right-icon">
          <van-icon :name=" passwordType1 === 'password' ? 'closed-eye':'eye-o'" @click="passwordType1 = passwordType1 == 'password'?'text':'password'"/>
        </template>
      </van-field>

      <van-button class="login-btn"   type="primary" size="normal" @click="save()">{{ $t("msg.确定") }}</van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      passwordType: "password",
      passwordType1: "password",
      o_new_password:"",
      t_new_password:"",
      old_password:"",
      userInfo:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    save(){
      if(this.o_new_password === "" || this.o_new_password === null || this.o_new_password === undefined){
        this.$toast.fail(this.$t("msg.请填写完整"));
        return false;
      }
      if(this.t_new_password === "" || this.t_new_password === null || this.t_new_password === undefined){
        this.$toast.fail(this.$t("msg.请填写完整"));
        return false;
      }
      /*if(this.old_password === "" || this.old_password === null || this.old_password === undefined){
        this.$toast.fail(this.$t("msg.请填写完整"));
        return false;
      }*/
      if(this.o_new_password !== this.t_new_password){
        this.$toast.fail(this.$t("msg.两次密码不一致！"));
        return false;
      }
      this.$http({
        method: 'get',
        data:{
          old_password:this.old_password,
          new_password:this.o_new_password,
        },
        url: 'user_set_paypw'
      }).then(res=>{
        this.old_password = "";
        this.o_new_password = "";
        this.t_new_password = "";
        /*if(res.code === 200){
          setTimeout(() => {
            localStorage.clear()
            this.$router.push("Login")
          }, 500);

        }*/
        this.$toast(this.$t("msg."+res.msg));
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
        }else if(res.code ===401){
          this.$toast(this.$t(res.msg));
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
    }
  }
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";
.loginForm{
  margin: 0 50px;
}
.van-cell {
  font-size: 35px;
  line-height: 80px;
}
.login-btn{
  margin-top: 50px;
  width: 100%;
  height: 100px;
  border-radius: 15px;
  color: #fff;
  background: linear-gradient(99.09deg, #66bcff 0%, #ec1d25 100%);
  font-size: 34px;
  font-weight: bolder;
  border: none;
}
</style>
